/**
 * ScreenFX — camera-level effects: screen shake, flash, fade.
 *
 * Operates on the scene's main camera. Game-agnostic.
 */

export interface ScreenShakeOptions {
  /** Duration in ms. Default 150. */
  duration?: number;
  /** Intensity (0-1 range, maps to pixels). Default 0.01. */
  intensity?: number;
}

export interface ScreenFlashOptions {
  /** Duration in ms. Default 100. */
  duration?: number;
  /** Flash color as 0xRRGGBB. Default 0xffffff (white). */
  color?: number;
}

/**
 * Shake the camera.
 */
export function screenShake(scene: any, opts?: ScreenShakeOptions): void {
  const duration = opts?.duration ?? 150;
  const intensity = opts?.intensity ?? 0.01;
  scene.cameras.main.shake(duration, intensity);
}

/**
 * Flash the camera (brief full-screen color overlay).
 */
export function screenFlash(scene: any, opts?: ScreenFlashOptions): void {
  const duration = opts?.duration ?? 100;
  const color = opts?.color ?? 0xffffff;

  const r = (color >> 16) & 0xff;
  const g = (color >> 8) & 0xff;
  const b = color & 0xff;

  scene.cameras.main.flash(duration, r, g, b);
}
